import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H1 } from 'foundations-components/transitional/components/H1';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { CopyTextArea } from 'foundations-components/transitional/components/CopyTextArea';
import { NumberInput } from 'foundations-components/transitional/components/NumberInput';
import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { extractEmbedParametersFromAcademyUrl, getIFrameEmbedCode } from 'embedded-academy-lib';
import { useState } from 'react';
import { useUserInfo } from '../../accounts/accountsQueries';
import { useFullLesson } from '../../lessons/lessonQueries';
import { useShort } from '../../shortContent/shortContentQueries';
import { useCurrentVideoTime } from '../../video/components/VideoPlayerWithControls';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { getIsHubSpotter } from '../../../utils/hubspotterUtils';
import { useRef } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/transitional/components/View';
import { useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CopyEmbedCodeModal = ({
  onClose,
  title,
  lessonId,
  contentId,
  shortId,
  language
}) => {
  const {
    currentVideoTime
  } = useCurrentVideoTime(); // this value updates as the video plays
  const {
    current: videoTimeWhenModalWasOpened
  } = useRef(Math.round(currentVideoTime)); // use a stable reference to the value when the modal is first opened
  const [startAtTimeSelected, setStartAtTimeSelected] = useState(false);
  const [startAtTime, setStartAtTime] = useState();
  const embedCode = getIFrameEmbedCode({
    lessonId,
    contentId,
    shortId,
    language,
    startTime: startAtTimeSelected ? startAtTime || videoTimeWhenModalWasOpened : 0
  });
  const theme = useTheme();
  if (!embedCode) return null;
  return /*#__PURE__*/_jsxs(Modal, {
    use: "conversational",
    width: 600,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      marginBlockEnd: "400",
      children: [/*#__PURE__*/_jsx(H1, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.embedModal.title",
          options: {
            contentName: title
          }
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      marginBlockStart: "400",
      style: {
        textAlign: 'unset'
      },
      children: [/*#__PURE__*/_jsx("div", {
        dangerouslySetInnerHTML: {
          __html: embedCode
        },
        style: {
          marginBlockEnd: theme.space['200']
        }
      }), /*#__PURE__*/_jsx(Checkbox, {
        checked: startAtTimeSelected,
        onChange: e => setStartAtTimeSelected(e.target.checked),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.embedModal.startTimeCheckbox"
        })
      }), /*#__PURE__*/_jsx(FormControl, {
        label: I18n.text('learningCenter.embedModal.startTimeLabel'),
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(NumberInput, {
          disabled: !startAtTimeSelected,
          onChange: e => {
            setStartAtTime(+e.target.value);
          },
          value: startAtTime || videoTimeWhenModalWasOpened
        })
      }), /*#__PURE__*/_jsx(CopyTextArea, {
        buttonUse: "primary",
        use: "code",
        value: embedCode
      })]
    })]
  });
};
const CopyEmbedCodeMenuOption = ({
  language
}) => {
  const {
    userInfo
  } = useUserInfo();
  const isHubspotter = getIsHubSpotter(userInfo);
  const [isOpen, setIsOpen] = useState(false);
  const {
    lessonId,
    contentId,
    shortId
  } = extractEmbedParametersFromAcademyUrl(window.location.toString());
  const {
    lesson
  } = useFullLesson(lessonId, undefined, !lessonId);
  const {
    short
  } = useShort(shortId, !shortId);
  const lessonVideoContent = lesson === null || lesson === void 0 ? void 0 : lesson.content.find(content => content.id === contentId && content.contentType === 'VIDEO');
  if (!(lessonId && contentId || shortId) ||
  // has valid embed parameters
  !isHubspotter || lesson && lesson.visibility !== 'PUBLIC' || lesson && !lessonVideoContent // only videos can be embedded
  ) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      block: true,
      onClick: () => setIsOpen(true),
      use: "unstyled",
      children: /*#__PURE__*/_jsx(View, {
        inlineSize: "100%",
        children: /*#__PURE__*/_jsx(SideNavItem, {
          role: "navigation-item",
          title: I18n.text('learningCenter.cardMenu.copyEmbedCode')
        })
      })
    }), isOpen && /*#__PURE__*/_jsx(CopyEmbedCodeModal, {
      contentId: contentId,
      language: language,
      lessonId: lessonId,
      onClose: () => setIsOpen(false),
      shortId: shortId,
      title: (lessonVideoContent === null || lessonVideoContent === void 0 ? void 0 : lessonVideoContent.name) || (short === null || short === void 0 ? void 0 : short.name) || ''
    })]
  });
};
export default CopyEmbedCodeMenuOption;